import { Table } from 'antd'
import React from 'react'

export default function LedgerAccountPreviewTable({ data, blank }) { 
   const ledgerFields = data.length > 0 ? data[0].fields.map((f, i) => f.title) : data

  return (
      <Table
          dataSource={data}
          rowKey={(r) => r.id}>
          <Table.Column title="Account Name" key="name" dataIndex="name" />
          {ledgerFields.map((fieldTitle, index) => (
              <Table.Column title={fieldTitle} key={fieldTitle} render={(_, record) => !blank ? record.fields?.[index]?.value : ''} />
          ))}
      </Table>
  )
}